import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../state';
import styles from './loginModal.module.scss';
import { WithSpinner } from './../../components';
import { Link } from 'react-router-dom';
import { config, isProd, isTest } from '../../api/config';
import swal from 'sweetalert';

const LoginModal = ({ dispatch, open, loginErr, loading }) => {
  const [values, setValues] = useState({
    email: '',
    password: '',
    companyCode: '',
    personalCode: '',
  });

  const handleLoginInputChange = ({ target: { name, value } }) => {
    setValues({ ...values, [name]: value });
  };

  const onTestLogin = () => {
    dispatch(actions.auth.loginTestViispCredAction(values));
  };

  const checkUrlAddress = () => {
    const url = window.location.hostname;
    if (url !== 'tiesioginespaskolos.ilte.lt') {
      return true;
    } else {
      return false;
    }
  };

  const letLogin = () => {
    const getTime = new Date();
    const showAfter = new Date('2020-09-30T17:00:00.00');
    const showTill = new Date('2020-10-01T06:00:00.00');

    if (getTime > showAfter && getTime < showTill) {
      return false;
    }
    return true;
  };

  const showMessage = () => {
    swal({
      title:
        'Informuojame, kad dėl VĮ Registrų centro vykdomų informacinės sistemos darbų, nuo rugsėjo 30 d. (17 val.) iki spalio 1 d. (6 val.) nebus galimybės prisijungti ir pateikti paraiškų. Atsiprašome už laikinus nepatogumus.',
      icon: 'warning',
      buttons: {
        confirm: {
          text: 'Gerai',
          value: true,
          visible: true,
          className: 'btn swal-ok-btn',
          closeModal: true,
        },
      },
    });
  };

  const goToMainWindow = () => {
    window.location.href = isProd()
      ? 'https://paslaugos.ilte.lt/'
      : isTest()
      ? 'https://barzda-test.ilte.lt/'
      : 'https://barzda.scorify.lt/';
  };
  
  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
          style={{ minHeight: '600px' }}
        >
          <WithSpinner loading={loading}>
            <div className={styles.loginInputsContainer}>
              <div>
                <h4>
                  Paraiškas gali teikti tik juridinio asmens
                  vadovas/verslininkas arba įgaliotas asmuo
                </h4>
              </div>
              <button
                type="button"
                className="btn ui-button btn-white  vaiisisloginbtn"
                onClick={(e) => goToMainWindow()}
              >
                {letLogin() ? (
                  <span>Prisijungti</span>
                ) : (
                  <span
                    className="btn btn-primary"
                    onClick={() => showMessage()}
                  >
                    Prisijungti per El. valdžios vartus
                  </span>
                )}
              </button>
            </div>
            <div className={styles.infoContainer}>
              <p style={{ fontSize: '1rem' }}>
                {' '}
                <b>
                  Prieš pradėdamas pildyti paraišką pareiškėjas privalo:
                </b>{' '}
              </p>
              <br />
              <p>
                1) Paraiškos pateikimo metu Paskolos gavėjas yra pateikęs
                valstybės įmonei Registrų centrui finansinių ataskaitų rinkinį,
                kuriame išsamiai nurodyta nuosavo kapitalo sudėtis. Jei Paskolos
                gavėjas priklauso įmonių grupei, kaip ji apibrėžta Lietuvos
                Respublikos įmonių grupių konsoliduotosios finansinės
                atskaitomybės įstatyme, valstybės įmonei Registrų centrui turi
                būti pateikusi įmonių grupės konsoliduotųjų finansinių ataskaitų
                rinkinį, kuriame išsamiai nurodyta nuosavo kapitalo sudėtis. Jei
                dėl Paskolos kreipiasi verslininkas, jis turi pateikti INVEGAI
                finansinius dokumentus;
              </p>
              <p>
                2) Paraiškos vertinimo metu Paskolos gavėjas atitinka minimalius
                patikimų mokesčių mokėtojų kriterijus, nustatytus Lietuvos
                Respublikos mokesčių administravimo įstatymo 40<sup>1</sup>{' '}
                straipsnyje. Atitiktis šiam reikalavimui vertinama pagal
                Valstybinės mokesčių inspekcijos prie Lietuvos Respublikos
                finansų ministerijos informaciją, skelbiamą interneto svetainėje
                <a
                  style={{ color: '#033878' }}
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.vmi.lt/evmi/mokesciu-moketoju-informacija"
                >
                  {' '}
                  https://www.vmi.lt/evmi/mokesciu-moketoju-informacija
                </a>
                ;
              </p>
              <p>
                3) Paraiškos pateikimo metu Paskolos gavėjui nėra iškelta
                bankroto ir (ar) restruktūrizavimo byla pagal Lietuvos
                Respublikos juridinių asmenų nemokumo įstatymą arba iki jo
                įsigaliojimo galiojusius Lietuvos Respublikos įmonių bankroto
                įstatymą ir Lietuvos Respublikos įmonių restruktūrizavimo
                įstatymą arba, jei pareiškėjas yra verslininkas, kaip apibrėžta
                SVV įstatyme, jam nėra iškelta fizinio asmens bankroto byla
                pagal Lietuvos Respublikos fizinių asmenų bankroto įstatymą;
              </p>
              <p>
                4) Paskolos gavėjas nėra valstybės ir savivaldybių įmonė ir
                įmonė, kurioje 25 procentus ir daugiau įmonės akcijų, pajų ar
                kitokių dalyvavimą įmonės kapitale žyminčių kapitalo dalių arba
                25 procentus ir daugiau įmonės dalyvių balsų tiesiogiai ar
                netiesiogiai (pagal balsavimo sutartį, balsavimo teisės
                perleidimo sutartį, įgaliojimą ir pan.) atskirai arba kartu turi
                valstybė ir (ar) savivaldybė.
              </p>
              <br />
              <p style={{ fontSize: '1rem' }}>
                <b> Bendra informacija pareiškėjams teikiama:</b>
              </p>

              <p style={{ marginTop: '10px' }}>
                Elektroniniu paštu:{' '}
                <b>
                  <a
                    style={{ color: '#033878' }}
                    href="mailto:uzklausos@ilte.lt"
                  >
                    uzklausos@ilte.lt{' '}
                  </a>
                </b>
              </p>
              <p>
                Telefonu: <b>+370 5 210 7510</b>
              </p>

              <br />
            </div>
          </WithSpinner>
          {checkUrlAddress() && (
            <div style={{ marginTop: '109px' }}>
              <fieldset>
                <legend>Direktorius:</legend>
                <div>
                  <input
                    className="m-input"
                    placeholder="CompanyCode"
                    name="companyCode"
                    type="text"
                    onChange={handleLoginInputChange}
                  />
                  <input
                    className="m-input"
                    placeholder="PersonalCode"
                    name="personalCode"
                    type="text"
                    onChange={handleLoginInputChange}
                  />
                </div>
                <div>
                  <input
                    className="m-input"
                    placeholder="Email"
                    name="email"
                    type="text"
                    onChange={handleLoginInputChange}
                  />
                  <input
                    className="m-input"
                    placeholder="Password"
                    name="password"
                    type="text"
                    onChange={handleLoginInputChange}
                  />
                </div>
                <div>
                  <button type="button" onClick={(e) => onTestLogin()}>
                    Login
                  </button>
                </div>
              </fieldset>
            </div>
          )}
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  loggedIn: state.auth.loggedIn,
  loginErr: state.auth.loginErr,
  loading: state.auth.loading,
});

export default connect(mapStateToProps)(LoginModal);
